import { Injectable } from '@angular/core';
import { randomUuid } from './uuid.util';

const STORAGE_KEY = 'polpaico_device_id';

@Injectable({ providedIn: 'root' })
export class DeviceIdService {
  private cached: string | null = null;

  getDeviceId(): string {
    if (this.cached) {
      return this.cached;
    }
    try {
      let id = localStorage.getItem(STORAGE_KEY);
      if (!id) {
        id = randomUuid();
        localStorage.setItem(STORAGE_KEY, id);
      }
      this.cached = id;
      return id;
    } catch {
      this.cached = randomUuid();
      return this.cached;
    }
  }
}
